define(["require", "exports", "jquery", "knockout", "log", "mimetype", "viewer", "../../utils/tools", "../../models/UserContext", "../../models/CustomerDocumentModel"], function (require, exports, $, ko, log, mimetype, Viewer, tools, UserContext, CustomerDocumentModel) {
    "use strict";
    var CustomerDocuments = /** @class */ (function () {
        function CustomerDocuments(customerId, lookupLists, initGridCallback) {
            this.userCanViewDocuments = ko.observable(UserContext.hasAccess("Admin,CustomerDocuments.View,CustomerDocuments.Edit,CustomerDocuments.Delete"));
            this.userCanEditDocuments = ko.observable(UserContext.hasAccess("Admin,CustomerDocuments.Edit,CustomerDocuments.Delete"));
            this.userCanDeleteDocuments = ko.observable(UserContext.hasAccess("Admin,CustomerDocuments.Delete"));
            this.editDocumentModel = ko.observable(new CustomerDocumentModel());
            this.customerId = ko.observable(0);
            this.uploadComplete = ko.observable(false);
            this.btn = ko.observable();
            var self = this;
            self.customerId(customerId);
            self.lookupLists = lookupLists;
            self.documentCategories = lookupLists.DocumentCategories;
            mimetype.set('.rsc', 'microtik/text');
            self.initGridCallback = initGridCallback;
        }
        CustomerDocuments.prototype.initGrid = function () {
            if (this.userCanViewDocuments()) {
                this.initDocumentsTree();
                //ko.applyBindings(this, document.getElementById("divCdrSummaryTable"));
                if (this.initGridCallback) {
                    this.initGridCallback(this);
                }
            }
        };
        CustomerDocuments.prototype.initDocumentsTree = function () {
            var self = this;
            var gridId = "divDocumentTable";
            var dataSource = new kendo.data.HierarchicalDataSource({
                transport: {
                    read: {
                        url: "/CustomerDocuments/GetDocumentsTree",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.customerId = self.customerId();
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: {
                        children: "Children",
                        id: "Id",
                        hasChildren: function (dataItem) {
                            return dataItem.Children.length > 0;
                        }
                    }
                }
            });
            var gridJQuery = $("#" + gridId);
            self.documentTable = gridJQuery.kendoTreeView({
                template: function (data) {
                    data.canEdit = self.userCanEditDocuments();
                    data.canView = self.userCanViewDocuments();
                    data.canDelete = self.userCanDeleteDocuments();
                    var template = kendo.template($("#customer-documents-template").html());
                    return template(data);
                },
                dataSource: dataSource,
                dataTextField: ["Name"],
                dataBound: function (e) {
                    console.log("DataBound", e.node);
                }
            }).data("kendoTreeView");
            gridJQuery.on("click", ".btn-edit", function (event) {
                var grid = $(event.currentTarget).closest(".k-treeview").data("kendoTreeView");
                var row = $(event.currentTarget).closest(".k-item");
                var data = grid.dataItem(row);
                self.editDocumentInternal(data.Id, self.customerId());
                event.preventDefault();
            }).on("click", ".btn-add", function (event) {
                var grid = $(event.currentTarget).closest(".k-treeview").data("kendoTreeView");
                var row = $(event.currentTarget).closest(".k-item");
                var data = grid.dataItem(row);
                self.editDocumentInternal(0, self.customerId(), data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var grid = $(event.currentTarget).closest(".k-treeview").data("kendoTreeView");
                var row = $(event.currentTarget).closest(".k-item");
                var data = grid.dataItem(row);
                self.deleteCustomerDocumentConfirm(data.Id, data.Name);
                event.preventDefault();
            }).on("click", ".btn-preview", function (event) {
                var grid = $(event.currentTarget).closest(".k-treeview").data("kendoTreeView");
                var row = $(event.currentTarget).closest(".k-item");
                var data = grid.dataItem(row);
                //alert(data.Name);
                self.previewDocument(data, event.currentTarget);
                event.preventDefault();
            });
        };
        CustomerDocuments.prototype.deleteCustomerDocument = function (docId) {
            var self = this;
            $.ajax({
                url: "/CustomerDocuments/DeleteDocument",
                type: "GET",
                data: { docId: docId },
                success: function (data) {
                    if (data.Success) {
                        tools.success("Document deleted successfully");
                        self.documentTable.dataSource.read();
                    }
                    if (data.Error) {
                        tools.error(data.Error);
                    }
                }
            });
        };
        CustomerDocuments.prototype.deleteCustomerDocumentConfirm = function (docId, docName) {
            var self = this;
            tools.confirmModal({
                title: "Delete Document",
                text: 'Are you sure you want to delete "' + docName + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerDocument(docId);
            });
        };
        CustomerDocuments.prototype.previewDocument = function (docItem, elm) {
            var self = this;
            var viewer, downloadLink;
            var mime = mimetype.lookup(docItem.Name);
            log.log(mime);
            if (!mime) {
                downloadLink = $(elm).next('.btn-download')[0];
                if (downloadLink) {
                    downloadLink.click();
                }
                return;
            }
            if (mime.indexOf("image") > -1) {
                $("#docPreviewContainer")
                    .empty()
                    .append("<img src='/CustomerDocuments/PreviewDocument?id=".concat(docItem.Id, "' alt='").concat(docItem.Name, "'>"));
                var options = {
                    url: "data-original",
                    ready: function (event) {
                        // 2 methods are available here: "show" and "destroy".
                        $("#mainContext .viewer-canvas").on("click", function (event) {
                            if (event.currentTarget === event.target) {
                                viewer.destroy();
                            }
                        });
                        log.log('ready: ', event);
                    },
                    hidden: function (event) {
                        viewer.destroy();
                    }
                };
                viewer = new Viewer(document.getElementById("docPreviewContainer"), options);
                viewer.show();
            }
            else if (mime.indexOf("audio") > -1) {
                tools.editModal({
                    title: "Preview Audio",
                    buttonTitle: "Close",
                    type: "info",
                    modalOptions: {},
                    save: function (event, modal) {
                        $(modal).modal("hide");
                    },
                    opened: function (modal) {
                        $(modal)
                            .find(".modal-body")
                            .html("<audio id=\"audioPlayer\" controls preload=\"auto\" ><source src=\"/CustomerDocuments/PreviewMedia?id=".concat(docItem.Id, "\" type=\"").concat(mime, "\"></audio>"));
                    }
                });
            }
            else if (mime.indexOf("video") > -1) {
                tools.editModal({
                    title: "Preview Video",
                    buttonTitle: "Close",
                    type: "info",
                    modalOptions: {},
                    save: function (event, modal) {
                        $(modal).modal("hide");
                    },
                    opened: function (modal) {
                        $(modal)
                            .find(".modal-body")
                            .html("<video width=\"100%\" controls ><source src=\"/CustomerDocuments/PreviewMedia?id=".concat(docItem.Id, "\" type=\"").concat(mime, "\"></video>"));
                    }
                });
            }
            else if (mime.indexOf("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") > -1
                || mime.indexOf("application/vnd.openxmlformats-officedocument.spreadsheetml.template") > -1
                || mime.indexOf("application/vnd.ms-excel") > -1
                || mime.indexOf("application/msword") > -1
                || mime.indexOf("application/vnd.openxmlformats-officedocument.wordprocessingml.document") > -1
                || mime.indexOf("application/vnd.openxmlformats-officedocument.wordprocessingml.template") > -1
                || mime.indexOf("application/vnd.ms-powerpoint") > -1
                || mime.indexOf("application/vnd.openxmlformats-officedocument.presentationml.presentation") > -1) {
                tools.editModal({
                    title: "Preview Pdf",
                    //modalClass: "full-width",
                    buttonTitle: "Close",
                    type: "info",
                    modalOptions: {},
                    save: function (event, modal) {
                        $(modal).modal("hide");
                    },
                    opened: function (modal) {
                        $(modal).find(".modal-body").html("<iframe src=\"/ViewerJS/#../CustomerDocuments/PreviewDocument?id=".concat(docItem.Id, "\" width='100%' height='600' allowfullscreen webkitallowfullscreen></iframe>"));
                    }
                });
            }
            else if (mime.indexOf("text") > -1) {
                tools.editModal({
                    title: "Preview Text",
                    buttonTitle: "Close",
                    type: "info",
                    modalOptions: {},
                    save: function (event, modal) {
                        $(modal).modal("hide");
                    },
                    opened: function (modal) {
                        $(modal).find(".modal-body").html("<iframe src=\"/CustomerDocuments/PreviewDocument?id=".concat(docItem.Id, "&previewAsText=true\" width='100%' height='600' allowfullscreen webkitallowfullscreen></iframe>"));
                    }
                });
            }
            else {
                downloadLink = $(elm).next('.btn-download')[0];
                if (downloadLink) {
                    downloadLink.click();
                }
            }
        };
        CustomerDocuments.prototype.editDocumentInternal = function (id, customerId, parentId) {
            var self = this;
            self.customerId(customerId);
            var title = "Add Document";
            if (id > 0) {
                title = "Edit Document";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.editDocumentModel().ParentId()) {
                        tools.error("No Directory selected!");
                        return;
                    }
                    if (self.editDocumentModel().DocType() === 1) {
                        if (id === 0 && self.uploadComplete() === false) {
                            tools.error("No document selected!");
                            return;
                        }
                    }
                    else if (self.editDocumentModel().DocType() === 1) {
                        if (!self.editDocumentModel().Name()) {
                            tools.error("Folder Name is required");
                            return;
                        }
                    }
                    $(event.currentTarget).button("loading");
                    self.btn(event.currentTarget);
                    var vis = $(".k-upload .k-file").is(":visible");
                    if (vis === false) {
                        var obj = ko.mapping.toJS(self.editDocumentModel);
                        tools.ajaxPost({
                            url: "/CustomerDocuments/UploadDocument",
                            data: {
                                customerId: self.customerId(),
                                documentId: obj.Id,
                                parentId: obj.ParentId,
                                description: obj.Description,
                                docType: obj.DocType,
                                name: obj.Name
                            }
                        }).done(function (result) {
                            var _a;
                            if (result.Success) {
                                tools.success("Changes updated successfully");
                                (_a = self.documentTable) === null || _a === void 0 ? void 0 : _a.dataSource.read();
                                $(modal).modal("hide");
                                return;
                            }
                            else {
                                tools.error(result.Error);
                            }
                        }).always(function () {
                            $(event.currentTarget).button("reset");
                        });
                    }
                    else {
                        $(".k-upload-selected").click();
                    }
                },
                opened: function (modal) {
                    var getLookupCall = tools.ajaxGet({
                        url: "/CustomerDocuments/GetDocumentsLookupData",
                        data: { customerId: self.customerId() },
                        success: function (result) {
                            if (result.Success) {
                                self.lookupLists = result.Data.lookupLists;
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    var getModelCall = null;
                    if (id > 0) {
                        getModelCall = tools.ajaxPost({
                            url: "/CustomerDocuments/GetDocumentById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editDocumentModel(new CustomerDocumentModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editDocumentModel(new CustomerDocumentModel);
                        self.editDocumentModel().CustomerId(self.customerId());
                        self.editDocumentModel().ParentId(parentId);
                    }
                    $.when(getModelCall, getLookupCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'c-doc-edit-template', data: editDocumentModel }\"></div>");
                        ko.applyBindings(self, modal);
                        $("#customerDocument", modal).kendoUpload({
                            async: {
                                saveUrl: "/CustomerDocuments/UploadDocument",
                                autoUpload: false
                            },
                            multiple: false,
                            select: function (e) {
                                setTimeout(function () {
                                    $(".k-upload-selected", modal).hide();
                                }, 10);
                                self.uploadComplete(true);
                            },
                            upload: function (e) {
                                e.data = {
                                    customerId: self.customerId(),
                                    documentId: id,
                                    description: self.editDocumentModel().Description(),
                                    parentId: self.editDocumentModel().ParentId(),
                                    docType: self.editDocumentModel().DocType()
                                };
                            },
                            localization: {
                                select: "Select a document"
                            },
                            success: function (e) {
                                var _a;
                                if (e.response) {
                                    if (e.response.Error) {
                                        tools.error(e.response.Error);
                                    }
                                    else {
                                        tools.success("Document uploaded successfully");
                                    }
                                    $(self.btn()).button("reset");
                                    $(modal).modal("hide");
                                    (_a = self.documentTable) === null || _a === void 0 ? void 0 : _a.dataSource.read();
                                    return;
                                }
                            }
                        });
                    });
                }
            });
        };
        CustomerDocuments.prototype.editDocument = function () {
            var self = this;
            if (self.userCanEditDocuments()) {
                self.editDocumentInternal(0, self.customerId());
            }
            else {
                tools.error("Permission denied!");
            }
        };
        return CustomerDocuments;
    }());
    return CustomerDocuments;
});
//# sourceMappingURL=customerDocuments.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerDocuments.js
// module id = 166
// module chunks = 2